// Import model
import { LeadNote } from '../models/LeadNote';

// Import base class serializer
import { NoteSerializer } from './NoteSerializer';

// Import dependency types (models and enums used in properties)
import { Entity } from '../models/Entity';

// Import dependency serializers (for complex types)
import { EntitySerializer } from './EntitySerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for LeadNote - handles JSON serialization and deserialization with type validation
 */
export class LeadNoteSerializer {
  /**
   * Deserializes a JSON string into a LeadNote instance
   */
  static deserialize(json: string): LeadNote {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a LeadNote instance
   */
  static fromObject(obj: any): LeadNote {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to LeadNote');
    }


    const instance: LeadNote = {
      parentObjectType: obj['parentObjectType'] as string,
      parentObjectTypeName: obj['parentObjectType|Name'] as string | undefined,
      type_: obj['type'] as string | undefined,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      flowId: obj['flowId'] as string | undefined,
      flowIdName: obj['flowId|Name'] as string | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      objectStatusIdName: obj['objectStatusId|Name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      lastModifiedDate: obj['lastModifiedDate'] as string | undefined,
      content: obj['content'] as string | undefined,
      contentType: obj['contentType'] as string | undefined,
      creatorId: obj['creatorId'] as string | undefined,
      creatorIdName: obj['creatorId|Name'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      relatedObjects: obj['relatedObjects'] as string | undefined,
      creator: obj['creator'] ? EntitySerializer.fromObject(obj['creator']) : undefined as any,
      _7F0490C9: obj['_7f0490c9'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of LeadNote instances
   */
  static deserializeArray(json: string): LeadNote[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a LeadNote instance to a JSON string
   */
  static serialize(instance: LeadNote): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a LeadNote instance to a plain object
   */
  static toObject(instance: LeadNote): any {
    return {
      'parentObjectType': instance.parentObjectType,
      'parentObjectType|Name': instance.parentObjectTypeName,
      'type': instance.type_,
      'name': instance.name,
      'description': instance.description,
      'flowId': instance.flowId,
      'flowId|Name': instance.flowIdName,
      'objectStatusId': instance.objectStatusId,
      'objectStatusId|Name': instance.objectStatusIdName,
      '_id': instance.id,
      'createdDate': instance.createdDate,
      'lastModifiedDate': instance.lastModifiedDate,
      'content': instance.content,
      'contentType': instance.contentType,
      'creatorId': instance.creatorId,
      'creatorId|Name': instance.creatorIdName,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
      'isActive': instance.isActive,
      'relatedObjects': instance.relatedObjects,
      'creator': instance.creator ? EntitySerializer.toObject(instance.creator) : undefined,
      '_7f0490c9': instance._7F0490C9,
    };
  }

  /**
   * Serializes an array of LeadNote instances to a JSON string
   */
  static serializeArray(instances: LeadNote[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
